'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../components/SingleValue');

var _transitions = require('./transitions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// instant fade; all transition-group children must be transitions

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return _react2.default.createElement(_transitions.Fade, _extends({ component: WrappedComponent }, props));
  };
};

exports.default = AnimatedSingleValue;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-select/lib/animated/SingleValue.js
 ** module id = 873
 ** module chunks = 0
 **/